import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addState = createAsyncThunk('addState', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'master-state',
            data: {
                "country_id": data?.values?.country,
                "state_name": data?.values?.stateName,
                "description": data?.values?.description,
                // "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})